import React from 'react';
import { _DividerContainer, _DividerIcon, _DividerLine, _Top, _TopDividerIcon } from "./style";
import { APPLICATION_STATUS as ApplicationStatusIcon, TIMELINE_BULLET as bullet, TIMELINE_RECENT_VIEW as BigBullet } from "../../../../util/cdnAssets";
function getDividerIcon(type) {
  if (type === 'applicationStatus') return ApplicationStatusIcon;
  return bullet;
}
export default function Divider(_ref) {
  var position = _ref.position,
    type = _ref.type;
  if (position === 'top' && type !== 'applicationStatus') {
    return /*#__PURE__*/React.createElement(_Top, null, /*#__PURE__*/React.createElement(_DividerLine, {
      position: position
    }), /*#__PURE__*/React.createElement(_TopDividerIcon, null, /*#__PURE__*/React.createElement("img", {
      src: BigBullet,
      alt: "*"
    })));
  } else {
    return /*#__PURE__*/React.createElement(_DividerContainer, null, /*#__PURE__*/React.createElement(_DividerLine, {
      className: type,
      position: position
    }), /*#__PURE__*/React.createElement(_DividerIcon, {
      className: type !== 'applicationStatus' ? 'bullet-icon' : null
    }, /*#__PURE__*/React.createElement("img", {
      src: getDividerIcon(type),
      alt: "-"
    })));
  }
}